import React from 'react';
import PropTypes from 'prop-types';

import { PaymentMethod } from '..';
import './PaymentMethodList.scss';
import { parseToInternalStructure } from 'parsers/paymentParser/paymentParser';

export const blockName = 'payment-method-list';

/**
 * PaymentMethodList component.
 *
 * @property {function} addAlertDetails - Callback function to add alert details.
 * @property {string} billToSiteNumber - The billing site number.
 * @property {number} corpAcctNbr - The corporate account number.
 * @property {boolean} [isSummaryPage] - Indicates if the component is rendered on the summary page (optional).
 * @property {string} [nextInvoiceDate] - The date of the next invoice (optional).
 * @property {array} paymentMethods - The list of payment method objects to display.
 * @property {function} startDeleteCreditCard - Callback function to start the delete credit card process.
 * @property {function} startSetDefaultPayment - Callback function to set the payment method as default.
 */
const PaymentMethodList = ({
  addAlertDetails,
  billToSiteNumber,
  corpAcctNbr,
  isSummaryPage,
  nextInvoiceDate,
  paymentMethods,
  startDeleteCreditCard,
  startSetDefaultPayment,
}) => (
  <article data-testid={blockName} className={blockName}>
    {paymentMethods.map((paymentMethod, index) => (
      <PaymentMethod
        addAlertDetails={addAlertDetails}
        billToSiteNumber={billToSiteNumber}
        corpAcctNbr={corpAcctNbr}
        isDefault={!paymentMethod.status}
        isSummaryPage={isSummaryPage}
        key={`${index}-${paymentMethod?.paymentMethodUuid}`}
        nextInvoiceDate={nextInvoiceDate}
        paymentMethod={parseToInternalStructure(paymentMethod)}
        startDeleteCreditCard={startDeleteCreditCard}
        startSetDefaultPayment={startSetDefaultPayment}
      />
    ))}
  </article>
);

PaymentMethodList.defaultProps = {
  isSummaryPage: false,
  nextInvoiceDate: '',
};

PaymentMethodList.propTypes = {
  addAlertDetails: PropTypes.func.isRequired,
  billToSiteNumber: PropTypes.string.isRequired,
  corpAcctNbr: PropTypes.number.isRequired,
  isSummaryPage: PropTypes.bool,
  nextInvoiceDate: PropTypes.string,
  paymentMethods: PropTypes.array.isRequired,
  startDeleteCreditCard: PropTypes.func.isRequired,
  startSetDefaultPayment: PropTypes.func.isRequired,
};

export default PaymentMethodList;
